module.exports = __webpack_public_path__ + "img/5277.a2d811b9.jpg";